import { useState } from "react";
import axios from "../customAxios.js";
import TrackingResults from "../components/TrackingResults.jsx";

function TrackingGT() {
  const [searchMode, setSearchMode] = useState("idReference"); 
  const [idReference, setIdReference] = useState("");
  const [loadingError, setLoadingError] = useState("");
  const [idAdmin, setIdAdmin] = useState(10);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [results, setResults] = useState([]);
  const [descriptionText, setDescriptionText] = useState(
    "Ingrese el número de referencia entregado por GlobalTracking"
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingError("");
    setResults([]);

    if (searchMode === "idReference" && !idReference) {
      setLoadingError("Ingrese el número de referencia");
      return;
    }

    setIsSubmitting(true);

    try {
      let response;

        if (searchMode === "idReference") {
        response = await axios.post("/exposed_api/globaltracking/tracking/", {
          idReference,
          idAdmin
        });
      }

      console.log("response.data:", response.data);
      setResults(response.data.orders || []);
    } catch (error) {
      setLoadingError("No se encontró información para esa orden.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleItemClick = (item) => {
    console.log("Clicked:", item.idReferencia);
  };

  return (
    <div className="tracking-container">
      <div className="green-header-tracking" align="center">
        <h4 className="title-login fw-medium">Global Tracking</h4>
      </div>

      <p className="tracking-description">{descriptionText}</p>

      {/* rest of the component remains the same */}
     
        <form onSubmit={handleSubmit} className="tracking-form">
              <label className="tracking-label">Número de Referencia</label>
              <input
                type="text"
                className="tracking-input"
                placeholder="Ej: 78910"
                value={idReference}
                onChange={(e) => setIdReference(e.target.value)}
              />

          <div className="tracking-button-container">
            <button
              type="submit"
              className="tracking-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Buscando..." : "Buscar"}
            </button>
          </div>

          {loadingError && <p className="tracking-error">{loadingError}</p>}
        </form>

      {results.length > 0 && (
        <TrackingResults results={results} onItemClick={handleItemClick} />
      )}
    </div>
  );
}

export default TrackingGT;
